import { Action, combineReducers, compose, Dispatch } from 'redux';
import { legacy_createStore as createStore } from 'redux';
import { auth_reducer } from './reducer/authReducer';

const root_reducer = combineReducers({
  user: auth_reducer,
});

// Integrate Redux DevTools
const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  process.env.NODE_ENV !== 'production'
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const enhancerInterceptor = composeEnhancers();

export const redux_store = createStore(root_reducer, enhancerInterceptor);

// Infer the redux store state type using utility type
export type ReduxRootStateType = ReturnType<typeof root_reducer>;

// define redux action dispatch type
export type ReduxActionDispatchType = Dispatch<Action>;
